import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Store } from 'rxjs-observable-store';
import { catchError, finalize } from 'rxjs/operators';
import { Logger } from '@clickd-angular/common-lib';
import { EM1 } from '../app.interfaces';
import { PagesGroups } from '../../../../pages/src/app/social-profile-configurations/social-profile-configurations.api';
import {
    AuthorizationUrl, EMStatus, SegmentationMembersApi, ReAuthResponse
} from './segmentation-members.api';


export class SegmentationMembersState {
  accountKey: string = 'atJrdi7f2EmJ0ZgoMyj97A';
  isBasicLicense = false;
  emStatus: EMStatus = EMStatus.Connectors;
  connectors: EM1["leads"];
  connector: EM1;
  isLoadingConnectors = false;
  totalElements: number;
  network: string;
  type: string = '';
  token: string = '';
  isUpdateValid: boolean = false;
  showSelection: boolean = false;
  pagesGroups: PagesGroups[] = [];
  isProfileLimitReached: boolean = false;
  otherError: boolean = false;
  isAuthSuccess: boolean = false;
}

@Injectable({providedIn: 'root'})

export class SegmentationMembersService extends Store<SegmentationMembersState> {
  constructor(
    private segmentationMembersApi: SegmentationMembersApi,
    private logger: Logger
  ) {
    super(new SegmentationMembersState());
  }

  async getConnectors(accountKey: string, segmentId: string, pageSize: number, pageId: number ,columnName: string, ascOrDesc: string) {
    if (true) {
      this.segmentationMembersApi
        .getConnectors(accountKey,segmentId,pageSize,pageId,columnName,ascOrDesc)
        .pipe(
          finalize(() => {
            this.patchState(false, 'isLoadingConnectors');
          })
        )
        .subscribe(
          (data) => {
            this.setState({
              ...this.state,
              emStatus: EMStatus.Connectors,
              connectors: data["leads"],
              totalElements: data.totalRecords,
            });
          },
          (error: any) => {
            this.logger.error(error);
          }
        );
    } 
  }
}
